import CreateBlockCommand from './create-block';
import BlockRange from '@intercom/embercom-composer/blocks/block-range';
import BlockSelection from '@intercom/embercom-composer/blocks/block-selection';
import Constants from '@intercom/embercom-composer/lib/constants';
export default CreateBlockCommand.extend({
  processZeroWidth() {
    this.set('options.text', '');
    return this._super();
  },
  processSingleBlock() {
    // TODO explicitly disallow lists
    let block = this.get('firstSelectedBlock');
    let blockText = block.get('text');
    let startIndex = this.get('selection.startPositionIndex');
    let endIndex = this.get('selection.endPositionIndex');
    let range = BlockRange.atPositionIndex(startIndex, endIndex);
    let entitiesInSelection = block.get('entities').withinRange(range);
    let newEntities = this._copyAndShiftEntites(entitiesInSelection, startIndex, endIndex);
    let newBlockText = blockText.slice(startIndex, endIndex);
    this.set('options.text', newBlockText);
    this.set('options.align', block.get('align'));
    this._expandSelectionToLineBreaks(blockText, startIndex, endIndex);
    let result = this._super();
    this._applyEntitiesToNewBlock(result, newEntities);
    this._autoCenterNewBlock(result);
    return result;
  },
  _expandSelectionToLineBreaks(blockText, startIndex, endIndex) {
    if (blockText.charAt(endIndex) === Constants.NEW_LINE) {
      this.expandSelectionRightBy(1);
    }
    if (blockText.charAt(startIndex - 1) === Constants.NEW_LINE) {
      this.expandSelectionLeftBy(1);
    }
  },
  _copyAndShiftEntites(entities, startIndex, endIndex) {
    let newEntities = [];
    entities.forEach(function (entity) {
      if (entity.get('startIndex') === endIndex || entity.get('endIndex') === startIndex) {
        return;
      }
      let newEntity = entity.copy();
      newEntity.shiftLeftBy(startIndex);
      if (newEntity.get('startIndex') < 0) {
        newEntity.set('startIndex', 0);
      }
      if (newEntity.get('endIndex') > endIndex - startIndex) {
        newEntity.set('endIndex', endIndex - startIndex);
      }
      newEntities.pushObject(newEntity);
    });
    return newEntities;
  },
  _applyEntitiesToNewBlock(result, newEntities) {
    let newBlock = result.get('newBlock');
    newEntities.forEach(function (entity) {
      newBlock.toggleEntity(entity.get('type'), BlockRange.atPositionIndex(entity.get('startIndex'), entity.get('endIndex')), entity.get('options'));
    });
  },
  _autoCenterNewBlock(result) {
    let newBlock = result.get('newBlock');
    let index = this._blockIndex(newBlock);
    let config = this.get('config');
    let autoCenter = config.get('autoCenter');
    if (index === 0 && config.get('allowAlignment') && autoCenter && autoCenter.includes('initialHeading')) {
      newBlock.set('align', 'center');
    }
  },
  processMultiBlock() {
    throw new Error('Cannot convert multiple blocks');
  },
  _setSelection(newBlock) {
    let newSelection = BlockSelection.create();
    let blockIndex = this._blockIndex(newBlock);
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: 0,
      startPositionIndex: 0,
      endBlockIndex: blockIndex,
      endItemIndex: 0,
      endPositionIndex: newBlock.get('text.length')
    });
    this.get('selection').setSelection(newSelection);
  }
});